module.exports = __webpack_public_path__ + "static/media/submit_succeed.73232387.png";